import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SummaryFieldComponent} from './summary-field.component';
import {IonicModule} from '@ionic/angular';
import {TextOverflowModule} from '../../../../shared/directives/text-overflow.module';
import {MatIconModule} from '@angular/material/icon';
import {TablerIconsModule} from "angular-tabler-icons";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TextOverflowModule,
        MatIconModule,
        TablerIconsModule,
    ],
    declarations: [
        SummaryFieldComponent,
    ],
    exports: [SummaryFieldComponent]
})
export class SummaryFieldModule {}